export default __webpack_public_path__ + "static/media/program_slide004.19be1dc0.png";